import { eObstacleType } from "./ObstacleTypes";



export class ObstacleSettings {
    /**
     * (RO) Typ prekazky
     */
    get type(): eObstacleType { return this._type; }
    private _type: eObstacleType;

    /**
     * (RO) Verze prekazky (v ramci typu)
     */
    get version(): number { return this._version; }
    private _version: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(type: eObstacleType, version: number) {
        this._type = type;
        this._version = version;
    }
}